export interface AsyncRequestOwnershipToken {
  generation: number;
  ownerKey: string;
}

export const buildAsyncRequestOwnerKey = (
  ...parts: Array<string | null | undefined>
): string => JSON.stringify(parts.map((part) => part ?? null));

export const isCurrentAsyncRequest = (
  currentGeneration: number,
  currentOwnerKey: string,
  token: AsyncRequestOwnershipToken,
): boolean => (
  token.generation === currentGeneration
  && token.ownerKey === currentOwnerKey
);
